import React, { useEffect, useMemo } from 'react';
import { AlgoliaConnectorContext } from './AlgoliaConnectorContext';
import algoliasearch from 'algoliasearch';
import { useFrame } from '../../frame';

type Props = {
    /**
     * Provide a refetch interval in milliseconds to clear the cache of the Algolia client.
     */
    refetchInterval?: number;
};

export const AlgoliaConnectorProvider = ({
    children,
    refetchInterval,
}: React.PropsWithChildren<Props>) => {
    const { data: frame } = useFrame();
    const algoliaApp = frame?.search?.algolia?.appKey ?? '';
    const algoliaToken = frame?.search?.algolia?.apiToken ?? '';

    const client = useMemo(() => algoliasearch(algoliaApp, algoliaToken), [
        algoliaApp,
        algoliaToken,
    ]);

    useEffect(() => {
        if (refetchInterval) {
            const refetchIntervalTimer = setInterval(function () {
                client.clearCache();
            }, refetchInterval * 1000);
            return () => clearInterval(refetchIntervalTimer);
        }
    }, [client, refetchInterval]);

    return (
        <AlgoliaConnectorContext.Provider value={client}>
            {children}
        </AlgoliaConnectorContext.Provider>
    );
};
